if (!customElements.get("navigation-drawer")) {
  // Global navigation manager to handle all menu interactions
  class NavigationManager {
    constructor() {
      this.parentMenu = document.querySelector(".mobile-menu");
      this.menuItems =
        this.parentMenu?.querySelectorAll(".menu__has-children") || [];
      this.allNavigationDrawers =
        this.parentMenu?.querySelectorAll("navigation-drawer") || [];
      this.init();
    }

    init() {
      this.menuItems.forEach((item) => {
        const link = item.querySelector("a");
        if (link) {
          link.addEventListener("click", (event) =>
            this.handleClick(event, item)
          );
        }
      });
    }

    handleClick(event, clickedItem) {
      event.preventDefault();

      const isOpen = clickedItem.classList.contains("menu__has-children--open");

      this.closeAllMenus();

      if (!isOpen) {
        this.openMenu(clickedItem);
      } else {
        this.clearInactiveIfNoneOpen();
      }
    }

    closeAllMenus() {
      this.menuItems.forEach((item) => {
        item.classList.remove("menu__has-children--open");

        const link = item.querySelector("a");
        if (link) {
          link.classList.remove("active");
          link.classList.add("inactive");
        }
      });

      // Close all navigation drawers
      this.allNavigationDrawers.forEach((drawer) => {
        drawer.classList.remove("navigation-drawer--open");
      });
    }

    openMenu(item) {
      const link = item.querySelector("a");
      if (link) {
        item.classList.add("menu__has-children--open");
        link.classList.remove("inactive");
        link.classList.add("active");

        // Find and open the corresponding navigation drawer
        this.openCorrespondingDrawer(item);
      }
    }

    openCorrespondingDrawer(menuItem) {
      // Find the navigation drawer that belongs to this menu item
      const correspondingDrawer = menuItem.querySelector("navigation-drawer");

      if (correspondingDrawer) {
        // Close all other drawers first
        this.allNavigationDrawers.forEach((drawer) => {
          if (drawer !== correspondingDrawer) {
            drawer.classList.remove("navigation-drawer--open");
          }
        });

        // Open the corresponding drawer
        correspondingDrawer.classList.add("navigation-drawer--open");
      }
    }

    clearInactiveIfNoneOpen() {
      const noneOpen = [...this.menuItems].every(
        (item) => !item.classList.contains("menu__has-children--open")
      );

      if (noneOpen) {
        this.menuItems.forEach((item) => {
          const link = item.querySelector("a");
          if (link) {
            link.classList.remove("inactive");
          }
        });
      }
    }
  }

  class NavigationDrawer extends HTMLElement {
    constructor() {
      super();

      this.closeButton = this.querySelector(".navigation-drawer__close button");

      // Initialize the global navigation manager only once
      if (!NavigationDrawer.managerInitialized) {
        NavigationDrawer.manager = new NavigationManager();
        NavigationDrawer.managerInitialized = true;
      }

      if (this.closeButton) {
        this.closeButton.addEventListener("click", () => this.closeDrawer());
      }
    }

    closeDrawer() {
      // Use the global manager to close all menus and drawers
      if (NavigationDrawer.manager) {
        NavigationDrawer.manager.closeAllMenus();
        NavigationDrawer.manager.clearInactiveIfNoneOpen();
      }

      // Close the drawer itself
      this.classList.remove("navigation-drawer--open");
    }
  }

  customElements.define("navigation-drawer", NavigationDrawer);
}
